import React from 'react';

const CustomInputDatePicker = React.forwardRef(({ value, onClick }, ref) => (
    <button
        type="button"
        className="custom-date-picker-button"
        onClick={onClick}
        ref={ref}
        style={{
            color: value ? '#333' : '#999',
        }}
    >
        {value || 'YYYY-MM'}
    </button>
));

export default CustomInputDatePicker;
